export default __webpack_public_path__ + "static/media/mail2.addc579b.svg";